import CartItem from "./CartItem"
import CartError from "./CartError"

type TCartItems = CartItem[] | CartError;

export default TCartItems;
